export type SubDomainMap = {
    host: string;
    api: string;
    logoUrl: string;
};

export enum ViewMode {
    Grid = "grid",
    List = "list",
    Mobile = "Mobile",
}

export enum InvestmentOptions {
    Home = "Home",
    Broking = "Broking",
    Global = "Global",
    USStocks = "US Stocks",
    USEtf = "US ETF",
    Alts = "Alts",
    UnlistedShares = "Unlisted Shares", // equal to Unlisted Equity
    Bullion = "Bullion",
    Bonds = "Bonds",
    FixedDeposits = "Fixed Deposits",
    Gold = "Digital Gold",
    Silver = "Pure Silver",
    FD = "FD",
    Portfolio = "Portfolio",
    Refer = "Refer",
}
